import { AnyFeedItemEntityVersion, StorageItem } from '@uploadcam/common';
import { CollectionReference, doc, writeBatch } from 'firebase/firestore';

export class UpdateFeedItemsAlbumInteractor {
  constructor(private readonly collection: CollectionReference<AnyFeedItemEntityVersion>) {}

  public async execute(albumId: string, folder: StorageItem, feedItemIds: string[]): Promise<void> {
    // TODO: `writeBatch` has a limit of 500 writes in the batch
    const batch = writeBatch(this.collection.firestore);

    feedItemIds.forEach((id) => {
      const docRef = doc(this.collection, id);

      batch.update(docRef, {
        albumId,
        driveId: folder.driveId,
        folderId: folder.id,
        folderName: folder.name,
      });
    });

    await batch.commit();
  }
}
